import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const PersonMediaSearchPage = withSuspense(lazy(() => import('./person-media')));
export default PersonMediaSearchPage;
